//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import NoResults from '@/components/client/NoResults'
import AxiosErrorHandler from '@/mixins/AxiosErrorHandler'
import ExperiencePreviewItem from '@/components/profile/ExperiencePreviewItem'
import LoadingOverlay from '~/components/ui/LoadingOverlay'
import ResumeLink from '~/components/profile/ResumeLink'

// noinspection JSUnusedGlobalSymbols
export default {
  name: 'ExperiencePreview',
  components: {
    ResumeLink,
    LoadingOverlay,
    ExperiencePreviewItem,
    NoResults
  },
  mixins: [AxiosErrorHandler],
  props: {
    freelancerId: {
      type: Number,
      required: true
    },
    resume: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      loading: false,
      experiences: [],
      resumes: []
    }
  },
  async mounted () {
    try {
      this.loading = true
      const resExperiences = await this.$axios.get(`/experiences/${this.freelancerId}`)
      this.experiences = resExperiences.data.data
      const resResumes = await this.$axios.get(`/freelancers/${this.freelancerId}/resumes`)
      this.resumes = resResumes.data.data
      this.loading = false
    } catch (err) {
      await this.handleError(err)
      this.loading = false
    }
  }
}
